import { makeStyles } from "@material-ui/core";
import search from '../../../assets/icons/servTopics/search.svg'

export const useStyles = makeStyles(theme => ({
    headingDiv: {
        display: 'flex',
        alignItems: "center",
        marginTop: 34
    },
    topicsFont: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#824ED2",
        marginRight: 11
    },
    topicsAll: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#5B6773"
    },
    greaterThanImg: {
        marginRight: 11.2,
        display: 'flex',
        alignItems: "center",
    },
    AddtopicsDiv: {
        display: "flex",
        marginTop: 30,
        width: "752px",
        minHeight: "536px",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "35px 40px 35px 40px",
        background: "#E6EDF3",
        borderRadius: "12px",
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%",
        },
    },
    AddTopicsText: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "26px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.0014em",
        color: "#091E42"
    },
    topicsNameText: {
        fontStyle: "normal",
        marginTop: "20px",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#091E42",
        marginBottom: 10

    },
    topicInput: {
        width: "672px",
        height: "49px",
        outline: "none",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        marginBottom: 30,
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%",
        },
    },
    advancetxt: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#091E42",
    },
    advanceAlign: {
        display: "flex",
        alignItems: "center"
    },
    advanceAlignArrow: {
        display: "flex",
        alignItems: "center",
        marginRight: 8
    },
    advanceGridTxt: {
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        color: "#091E42",
        marginRight: 12
    },
    subGridDivs: {
        display: "flex",
        alignItems: "center",
        marginTop: 30,
        marginBottom: 10
    },
    numberInput: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 16px",
        width: "211px",
        height: "51px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "8px",
        fontWeight: 400,
        fontSize: "16px",
        outline: "none",
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%",
        },
        '&::placeholder': {
            color: "black"
        }

    },
    subGridDivs2: {
        display: "flex",
        alignItems: "center",
        marginTop: 20,
        marginBottom: 10
    },
    cleanButton: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "10px 20px",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#824ED2",
        border: "1px solid #824ED2",
        borderRadius: "6px",
        marginTop: "29px",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: "100%"
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%"
        },
    },
    configButton: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "10px 20px",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#FFFFFF",
        border: "none",
        borderRadius: "6px",
        marginTop: "29px",
        background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: "100%"
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%"
        },
    },
    configAlign: {
        display: "flex",
        justifyContent: "flex-end",
        [theme.breakpoints.down('sm')]: {
            display: "block",
            justifyContent: "center",
        },
        [theme.breakpoints.down('xs')]: {
            display: "block",
            justifyContent: "center",
        },
    },
    topicListtxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "26px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.0014em",
        color: "#091E42"
    },
    searchtxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "26px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        letterSpacing: "-0.0014em",
        color: "#091E42"
    },
    searchinput: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "13px 14px",
        width: "752px",
        height: "50px",
        background: "#F4F6F8",
        border: "1px solid #D4DDE4",
        boxSizing: "border-box",
        borderRadius: "6px",
        outline: "none",
        marginTop: "10px",
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%",
        },
    },
    topicsNotFound: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "14px",
        lineHeight: "22px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.1px",
        color: "#5B6773",
        marginTop: 30
    },
    subSearchBarDiv: {
        marginTop: 30,
        width: "752px",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        /* identical to box height, or 138% */

        /* Text Color/Description Font-Color */

        color: '#5B6773',
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
        [theme.breakpoints.down('xs')]: {
            width: "100%",
        },
    },
    searchPosition: {
        paddingRight: "8.12px",
        padding: "15.28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        float: "right"
    },
    inputIcons: {
        width: "100%",
        position: "absolute",
        marginBottom: "10px"
    },
    icon: {
        padding: "10px",
        minWidth: "40px"
    },
    inputField: {
        width: "100%",
        padding: "10px",
        textAlign: "center"
    }

}))